module.exports = "/_next/static/images/UDJ5-86f77a2deb6ce6569487b70e2002b977.svg";